import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Container, Alert } from "react-bootstrap";
import SidebarLayout from "../../components/sidebarLayout";
import menuData from "../../data/menuData";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axios";
import "./qnaWrite.css";

export default function QnAWrite({ user, isUserLoaded }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    content: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(true);
  const qnaMenu = menuData.find((menu) => menu.title === "포럼소식");
  const alertShownRef = useRef(false); // alert 상태 관리

  useEffect(() => {
    if (!user && isUserLoaded) {
      setIsAuthorized(false);
      if (!alertShownRef.current) {
        alert("로그인 후 이용해주세요.");
        alertShownRef.current = true;
        navigate("/login");
      }
    }
  }, [user, isUserLoaded, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { title, content } = formData;

    if (!title || !content) {
      setError("제목과 내용을 모두 입력해주세요.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await axiosInstance.post("/api/qna/write", {
        title,
        content,
        authorEmail: user.email,
        author: user.name,
      });

      if (response.data.resultCode === "200") {
        setSuccess(true);
        setTimeout(() => {
          navigate("/qna");
        }, 2000);
      } else {
        setError(response.data.resultMessage || "Q&A 작성에 실패했습니다.");
      }
    } catch (err) {
      console.error("Error submitting Q&A:", err);
      setError("서버와의 통신 중 문제가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) {
    return null;
  }

  return (
    <div>
      <SidebarLayout menu={qnaMenu}>
        <Container>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && (
            <Alert variant="success">
              Q&A가 성공적으로 작성되었습니다. 목록으로 이동합니다.
            </Alert>
          )}
          <Form onSubmit={handleSubmit} className="qna-write-form">
            <Form.Group className="mb-3" controlId="formTitle">
              <Form.Label>
                제목 <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="제목을 입력하세요"
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formContent">
              <Form.Label>
                내용 <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={8}
                placeholder="내용을 입력하세요"
                name="content"
                value={formData.content}
                onChange={handleChange}
              />
            </Form.Group>

            <div className="d-flex justify-content-between">
              <Button variant="secondary" onClick={() => navigate("/qna")}>
                취소
              </Button>
              <Button
                style={{
                  backgroundColor: "#1769b3",
                  borderColor: "#1769b3",
                  color: "white",
                }}
                type="submit"
                disabled={loading}
              >
                {loading ? "등록 중..." : "등록"}
              </Button>
            </div>
          </Form>
        </Container>
      </SidebarLayout>
    </div>
  );
}
